module.exports = __webpack_public_path__ + "img/old.8ac67db.webp";